import { render, staticRenderFns } from "./ChannelOrderDetailList.vue?vue&type=template&id=557f5fd6&scoped=true&"
import script from "./ChannelOrderDetailList.vue?vue&type=script&lang=js&"
export * from "./ChannelOrderDetailList.vue?vue&type=script&lang=js&"
import style0 from "./ChannelOrderDetailList.vue?vue&type=style&index=0&id=557f5fd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557f5fd6",
  null
  
)

export default component.exports